import $ from 'jquery';

export default class ProductList {
  constructor({ el }) {
    this.$el = $(el);
    this.el = el;
    this._processImage = this._processImage.bind(this);
    this.el.addEventListener('rimg:load', this._processImage);
  }

  _processImage() {
    this.$el.find('.product-item-image:not(.processed)').each((index, imageWrapper) => {
      const $imageWrapper = $(imageWrapper);
      $imageWrapper.addClass('processed');

      const $image = $imageWrapper.find('img');

      if ($image.height() && $image.height() < 100) {
        $imageWrapper.find('.product-item-details-overlay').addClass('landscape');
      }
    });
  }

  unload() {
    this.el.removeEventListener('rimg:load', this._processImage);
  }
}
